const exp = {
  RCA: "RCA",
  CASCO: "CASCO",
  RTI:  "RTI"
};
export default exp;
